import Cookies from 'js-cookie'
const accountTypesKey = 'account_types'
const tokenKey = 'access_token'
const languageKey = 'language'
const xToken = 'X-Token'
export const utilCookies = {
  setAccountTypes(accountTypes) {
    Cookies.set(accountTypesKey, accountTypes)
  },
  getAccountTypes() {
    return Cookies.get(accountTypesKey)
  },
  setToken(Token) {
    Cookies.set(tokenKey, Token)
  },
  getToken() {
    return Cookies.get(tokenKey)
  },
  removeToken() {
    return Cookies.remove(tokenKey)
  },
  setLanguage(language) {
    Cookies.set(languageKey, language)
  },
  getLanguage() {
    return Cookies.get(languageKey)
  },
  getCompanyToken() {
    return Cookies.get(xToken)
  },
  setCompanyToken(Token) {
    Cookies.set(xToken, Token)
  },
  removeCompanyToken() {
    return Cookies.remove(xToken)
  },
  clear() {
    Object.keys(Cookies.get()).forEach(cookieName => Cookies.remove(cookieName))
  }
}
